var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotatedTrumpet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 158,
    viewBox: "0 0 157 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2829_12350)",
    filter: "url(#filter0_f_2829_12350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0167 70.2982C49.9117 72.3172 46.58 78.8454 48.5756 84.8794L50.3628 90.2834C52.3583 96.3174 58.9255 99.5723 65.0304 97.5533C74.7118 94.3516 85.131 94.1631 94.8814 97.0137L98.6269 98.1087L82.6573 49.8209L80.3034 52.9336C74.175 61.0351 65.6981 67.0964 56.0167 70.2982Z",
    fill: "url(#paint0_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6645 93.3108L55.7969 96.5742L58.5414 99.6725C60.3625 101.728 61.7446 104.129 62.6053 106.732L63.7471 110.184C64.6377 112.877 67.5686 114.33 70.2933 113.429C73.0184 112.528 74.5053 109.614 73.6147 106.921L72.4729 103.469C71.6122 100.866 70.2301 98.465 68.409 96.4091L65.6645 93.3108Z",
    fill: "url(#paint1_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1059 99.8255L63.9055 100.884C62.9026 101.216 62.3557 102.288 62.6835 103.279L62.6899 103.299C62.8684 103.838 63.2695 104.241 63.7593 104.444L73.7921 109.416C73.9382 108.607 73.8908 107.753 73.6152 106.919L72.4734 103.467C72.2504 102.793 71.9915 102.132 71.6999 101.488L68.6766 99.9891C68.2189 99.7223 67.6518 99.6449 67.1059 99.8255Z",
    fill: "url(#paint2_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2996 103.435L65.0992 104.493C64.0963 104.825 63.0178 104.29 62.6899 103.299L62.6835 103.279C62.3557 102.288 62.9026 101.216 63.9055 100.884L67.1059 99.8255C68.1088 99.4938 69.1878 100.029 69.5157 101.02L69.5221 101.039C69.8499 102.031 69.3026 103.103 68.2996 103.435Z",
    fill: "url(#paint3_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5793 105.754C70.1218 105.488 69.5547 105.41 69.0087 105.591L65.8083 106.649C64.8054 106.981 64.2578 108.053 64.5857 109.045L64.5923 109.065C64.7706 109.604 65.1722 110.006 65.662 110.209L71.272 112.99C73.2409 111.853 74.2697 109.545 73.7227 107.313L70.5793 105.754Z",
    fill: "url(#paint4_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2038 109.198L67.0033 110.257C66.0004 110.588 64.9221 110.054 64.5942 109.063L64.5876 109.043C64.2598 108.051 64.8068 106.979 65.8098 106.648L69.0102 105.589C70.0131 105.257 71.092 105.792 71.4198 106.783L71.4264 106.803C71.7542 107.794 71.2067 108.867 70.2038 109.198Z",
    fill: "url(#paint5_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1187 105.421L72.4729 103.469C71.6122 100.866 70.2301 98.465 68.4092 96.4096L65.6645 93.3108L55.7969 96.5742L56.2106 97.0414L73.1187 105.421Z",
    fill: "url(#paint6_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2895 85.6565C56.2224 88.4774 54.6647 91.5299 51.8106 92.4738C48.956 93.4179 45.8859 91.8959 44.953 89.0749C44.0201 86.254 45.5773 83.2016 48.4319 82.2576C51.286 81.3137 54.3566 82.8356 55.2895 85.6565Z",
    fill: "url(#paint7_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0224 86.5872L61.7449 79.7007C60.3068 75.3523 61.0402 70.8032 63.3552 67.205C61.005 68.4216 58.5521 69.4581 56.0161 70.2968C49.9112 72.3158 46.5796 78.8445 48.5752 84.8784L50.3624 90.2825C52.3579 96.3164 58.9251 99.5714 65.03 97.5524C67.566 96.7137 70.1533 96.0834 72.7653 95.6589C68.7616 94.1509 65.4604 90.9355 64.0224 86.5872Z",
    fill: "url(#paint8_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.737 67.7371C104.761 52.69 94.8102 42.4483 87.5117 44.8621C80.2136 47.2757 78.3311 61.4307 83.3074 76.4778C88.2837 91.5248 98.2346 101.766 105.533 99.3528C112.831 96.939 114.713 82.7841 109.737 67.7371Z",
    fill: "url(#paint9_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.03 68.9634C102.043 56.9077 94.9596 48.4084 90.2093 49.9794C85.4585 51.5506 84.8395 62.5971 88.8265 74.6528C92.8135 86.7085 99.8967 95.2078 104.647 93.6366C109.398 92.0656 110.017 81.0191 106.03 68.9634Z",
    fill: "url(#paint10_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.111 77.3758C108.129 77.4785 108.145 77.5811 108.16 77.6833C108.219 78.0524 108.271 78.4166 108.317 78.7783C108.336 78.9236 108.356 79.0678 108.371 79.2111C108.496 80.2294 108.578 81.2153 108.62 82.1629C108.627 82.3062 108.633 82.448 108.637 82.5883C108.639 82.603 108.638 82.6162 108.639 82.6295C108.643 82.7684 108.646 82.9078 108.649 83.0462C108.651 83.197 108.655 83.3481 108.653 83.4969C108.655 83.6172 108.655 83.7346 108.654 83.852C108.654 83.9035 108.654 83.9528 108.653 84.0048C108.651 84.131 108.648 84.2558 108.646 84.3786C108.643 84.5318 108.639 84.6854 108.631 84.8381C108.626 84.9702 108.619 85.1014 108.612 85.2311C108.608 85.3001 108.604 85.3706 108.599 85.4402C108.595 85.5092 108.59 85.5768 108.585 85.6463C108.575 85.7833 108.564 85.9174 108.552 86.0526C108.545 86.1324 108.538 86.2107 108.529 86.2915C108.521 86.3781 108.513 86.4638 108.502 86.548C108.492 86.6473 108.48 86.7454 108.467 86.8423C108.406 87.3334 108.328 87.8056 108.234 88.2547C107.644 91.0966 106.44 93.042 104.645 93.6356C100.571 94.9829 94.7799 88.9215 90.6998 79.5623C90.6447 79.4354 90.5889 79.3081 90.5347 79.1792C90.4342 78.9465 90.3347 78.7102 90.237 78.4711C90.2217 78.435 90.208 78.3983 90.1926 78.3617C90.0996 78.1319 90.0063 77.8995 89.9151 77.6653C89.8555 77.5149 89.7974 77.364 89.7393 77.2132C89.7265 77.1811 89.7147 77.1503 89.7022 77.1176L89.4968 76.5712C89.4914 76.5546 89.4859 76.538 89.479 76.524C89.4126 76.3429 89.348 76.1627 89.2829 75.9806C89.2706 75.9483 89.2602 75.9171 89.2484 75.8863L89.2439 75.8727C89.1981 75.7442 89.1519 75.616 89.1079 75.4864C89.0759 75.3963 89.0444 75.3059 89.0139 75.2136C88.9502 75.0261 88.8867 74.8391 88.8247 74.6516C88.7625 74.4636 88.702 74.2756 88.6415 74.0876C88.6119 73.9982 88.5839 73.9084 88.5561 73.8179C88.5098 73.668 88.4635 73.5181 88.4173 73.3682C88.4069 73.3369 88.3981 73.3052 88.3877 73.2739C88.3557 73.167 88.3242 73.062 88.2926 72.9565C88.2513 72.8217 88.2119 72.6874 88.1745 72.553C88.1297 72.4026 88.0864 72.2517 88.0444 72.0998C88.0396 72.0803 88.0326 72.0593 88.0276 72.0393C88.012 71.987 87.9982 71.9336 87.9839 71.882C87.8066 71.2451 87.6442 70.6114 87.4955 69.9845C87.4503 69.7979 87.4075 69.6122 87.3642 69.4266C87.5678 69.3295 87.7788 69.2435 87.9987 69.1707C89.5134 68.6698 91.0867 68.8629 92.3708 69.5753L108.111 77.3758Z",
    fill: "url(#paint11_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0086 84.1927L67.8035 84.2605C66.9399 84.5461 66.0109 84.0852 65.7286 83.2317L64.4701 79.4263C64.1878 78.5728 64.659 77.6493 65.5226 77.3637L65.7277 77.2959C66.5918 77.0102 67.5207 77.4706 67.8029 78.3241L69.0614 82.1295C69.3437 82.983 68.8726 83.9069 68.0086 84.1927Z",
    fill: "url(#paint12_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6394 82.6615L72.4344 82.7293C71.5708 83.0149 70.6417 82.554 70.3594 81.7004L69.101 77.8951C68.8187 77.0415 69.2899 76.1181 70.1535 75.8325L70.3585 75.7647C71.2226 75.4789 72.1515 75.9393 72.4338 76.7929L73.6923 80.5982C73.9746 81.4518 73.5035 82.3757 72.6394 82.6615Z",
    fill: "url(#paint13_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0222 86.5879L62.006 80.4914L59.1376 81.44C58.4049 81.6823 58.0048 82.4663 58.2443 83.1905L58.4857 83.9205C58.6125 84.3038 58.8935 84.5917 59.2376 84.7439L64.2525 87.2295C64.1717 87.0184 64.0941 86.8052 64.0222 86.5879Z",
    fill: "url(#paint14_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.006 80.4914L59.1376 81.44C58.4049 81.6823 58.0048 82.4663 58.2443 83.1905L58.4857 83.9205C58.7254 84.6451 59.5138 85.0355 60.2465 84.7932L63.1149 83.8446L62.006 80.4914Z",
    fill: "url(#paint15_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0016 69.1724C87.7818 69.2451 87.5704 69.3318 87.3661 69.4286C87.7547 71.1305 88.2405 72.881 88.8267 74.6535C89.394 76.369 90.0245 78.012 90.7014 79.5649C90.9283 79.5202 91.1548 79.4627 91.3801 79.3882C94.2342 78.4442 95.7921 75.3922 94.8592 72.5713C93.9261 69.7499 90.8557 68.2285 88.0016 69.1724Z",
    fill: "url(#paint16_linear_2829_12350)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2829_12350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2769 60.5823C39.5792 63.1281 35.3782 71.3595 37.8944 78.9677L40.1479 85.7817C42.6641 93.3899 50.9446 97.4941 58.6423 94.9483C70.8496 90.9112 83.9871 90.6735 96.2815 94.2679L101.004 95.6486L80.8681 34.7625L77.9001 38.6873C70.1728 48.9025 59.4842 56.5452 47.2769 60.5823Z",
    fill: "url(#paint17_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4421 89.5981L47 93.7129L50.4606 97.6195C52.7567 100.212 54.4995 103.239 55.5848 106.521L57.0244 110.874C58.1474 114.27 61.843 116.101 65.2785 114.965C68.7147 113.829 70.5894 110.155 69.4665 106.759L68.0269 102.406C66.9416 99.1244 65.1988 96.097 62.9027 93.5047L59.4421 89.5981Z",
    fill: "url(#paint18_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2603 97.8145L57.2249 99.1491C55.9603 99.5674 55.2707 100.92 55.6841 102.17L55.6922 102.194C55.9172 102.875 56.423 103.382 57.0405 103.638L69.691 109.908C69.8752 108.887 69.8154 107.81 69.4678 106.759L68.0282 102.406C67.747 101.556 67.4205 100.723 67.0529 99.9104L63.2408 98.0209C62.6637 97.6844 61.9487 97.5869 61.2603 97.8145Z",
    fill: "url(#paint19_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7655 102.366L58.73 103.7C57.4655 104.119 56.1056 103.444 55.6922 102.194L55.6841 102.17C55.2707 100.92 55.9603 99.5674 57.2249 99.1491L61.2603 97.8145C62.5249 97.3963 63.8854 98.0707 64.2988 99.3205L64.3069 99.3452C64.7203 100.595 64.0301 101.948 62.7655 102.366Z",
    fill: "url(#paint20_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6416 105.288C65.0647 104.952 64.3497 104.854 63.6613 105.082L59.6259 106.417C58.3613 106.835 57.6709 108.187 58.0843 109.437L58.0926 109.462C58.3174 110.142 58.8238 110.649 59.4414 110.905L66.5151 114.411C68.9976 112.978 70.2949 110.068 69.6052 107.253L65.6416 105.288Z",
    fill: "url(#paint21_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1676 109.633L61.1322 110.967C59.8676 111.386 58.5079 110.712 58.0946 109.462L58.0862 109.437C57.6728 108.187 58.3626 106.835 59.6272 106.417L63.6627 105.082C64.9272 104.664 66.2876 105.338 66.7009 106.588L66.7093 106.613C67.1226 107.863 66.4322 109.215 65.1676 109.633Z",
    fill: "url(#paint22_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8411 104.868L68.0269 102.406C66.9415 99.1244 65.1988 96.097 62.9029 93.5053L59.4421 89.5981L47 93.7129L47.5217 94.302L68.8411 104.868Z",
    fill: "url(#paint23_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3626 79.9489C47.5389 83.5058 45.5748 87.3547 41.976 88.5449C38.3767 89.7353 34.5056 87.8161 33.3293 84.2592C32.153 80.7023 34.1165 76.8536 37.7158 75.6632C41.3146 74.473 45.1862 76.392 46.3626 79.9489Z",
    fill: "url(#paint24_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3732 81.1219L54.5015 72.4387C52.6882 66.9559 53.6129 61.2199 56.5319 56.6829C53.5686 58.2168 50.4757 59.5239 47.2781 60.5814C39.5804 63.1271 35.3796 71.3591 37.8957 78.9673L40.1492 85.7813C42.6654 93.3895 50.946 97.4937 58.6437 94.948C61.8413 93.8905 65.1036 93.0957 68.3972 92.5604C63.3489 90.659 59.1864 86.6047 57.3732 81.1219Z",
    fill: "url(#paint25_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 57.354C108.74 38.3812 96.1934 25.4674 86.9907 28.5109C77.7885 31.5542 75.4148 49.4023 81.6895 68.3752C87.9641 87.348 100.511 100.262 109.713 97.2182C118.916 94.1747 121.289 76.3268 115.015 57.354Z",
    fill: "url(#paint26_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.339 58.9007C105.312 43.6997 96.3806 32.9829 90.391 34.9638C84.4008 36.9449 83.6202 50.8734 88.6475 66.0745C93.6747 81.2755 102.606 91.9923 108.596 90.0112C114.586 88.0303 115.366 74.1018 110.339 58.9007Z",
    fill: "url(#paint27_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.965 69.5081C112.988 69.6377 113.008 69.767 113.027 69.8959C113.101 70.3613 113.167 70.8205 113.225 71.2766C113.249 71.4597 113.274 71.6416 113.293 71.8222C113.451 73.1063 113.554 74.3493 113.607 75.5442C113.616 75.7248 113.623 75.9036 113.629 76.0806C113.631 76.0991 113.63 76.1157 113.631 76.1326C113.636 76.3077 113.64 76.4834 113.643 76.6579C113.647 76.848 113.651 77.0386 113.649 77.2262C113.651 77.378 113.652 77.526 113.65 77.674C113.65 77.7389 113.65 77.8011 113.648 77.8666C113.646 78.0257 113.643 78.1832 113.64 78.338C113.636 78.5312 113.631 78.7248 113.62 78.9174C113.615 79.0839 113.606 79.2494 113.597 79.4128C113.592 79.4999 113.588 79.5888 113.581 79.6765C113.576 79.7635 113.57 79.8488 113.563 79.9364C113.551 80.1091 113.537 80.2783 113.522 80.4487C113.513 80.5493 113.503 80.6481 113.493 80.75C113.482 80.8592 113.472 80.9672 113.459 81.0734C113.445 81.1986 113.431 81.3222 113.415 81.4444C113.337 82.0637 113.239 82.659 113.121 83.2254C112.377 86.8087 110.858 89.2616 108.595 90.0101C103.458 91.7089 96.1562 84.0661 91.0116 72.2651C90.942 72.1051 90.8717 71.9446 90.8034 71.7821C90.6767 71.4886 90.5512 71.1907 90.428 70.8892C90.4087 70.8436 90.3914 70.7975 90.372 70.7513C90.2547 70.4615 90.1371 70.1685 90.0221 69.8732C89.947 69.6835 89.8737 69.4933 89.8004 69.3031C89.7843 69.2626 89.7694 69.2238 89.7537 69.1826L89.4947 68.4937C89.4878 68.4727 89.4809 68.4518 89.4723 68.4341C89.3885 68.2057 89.3071 67.9785 89.2249 67.7489C89.2094 67.7083 89.1964 67.6689 89.1815 67.6301L89.1758 67.6128C89.1181 67.4509 89.0598 67.2892 89.0044 67.1258C88.964 67.0121 88.9243 66.8982 88.8858 66.7819C88.8055 66.5454 88.7254 66.3096 88.6473 66.0732C88.5689 65.8361 88.4925 65.5991 88.4162 65.362C88.379 65.2494 88.3436 65.1361 88.3086 65.022C88.2502 64.8329 88.1918 64.6439 88.1335 64.4549C88.1204 64.4155 88.1093 64.3755 88.0963 64.3361C88.0558 64.2012 88.0162 64.0688 87.9763 63.9358C87.9243 63.7659 87.8745 63.5966 87.8274 63.427C87.7709 63.2374 87.7163 63.0471 87.6633 62.8556C87.6573 62.831 87.6485 62.8045 87.6422 62.7793C87.6225 62.7134 87.6051 62.6461 87.587 62.581C87.3636 61.7779 87.1587 60.9789 86.9713 60.1884C86.9142 59.9532 86.8603 59.719 86.8057 59.485C87.0623 59.3625 87.3285 59.254 87.6057 59.1624C89.5156 58.5307 91.4994 58.7742 93.1185 59.6725L112.965 69.5081Z",
    fill: "url(#paint28_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3971 78.1032L62.1386 78.1886C61.0497 78.5488 59.8782 77.9676 59.5223 76.8914L57.9355 72.0932C57.5795 71.017 58.1737 69.8526 59.2626 69.4925L59.5212 69.407C60.6107 69.0467 61.7819 69.6272 62.1379 70.7034L63.7247 75.5016C64.0806 76.5778 63.4867 77.7428 62.3971 78.1032Z",
    fill: "url(#paint29_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2389 76.1696L67.9804 76.2551C66.8915 76.6152 65.72 76.034 65.3641 74.9578L63.7773 70.1596C63.4213 69.0834 64.0155 67.919 65.1044 67.5589L65.363 67.4734C66.4525 67.1131 67.6237 67.6936 67.9797 68.7698L69.5665 73.568C69.9224 74.6442 69.3285 75.8092 68.2389 76.1696Z",
    fill: "url(#paint30_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3733 81.1231L54.8311 73.436L51.2142 74.6322C50.2904 74.9377 49.786 75.9262 50.0879 76.8393L50.3924 77.7598C50.5522 78.2431 50.9065 78.6061 51.3404 78.798L57.6636 81.9321C57.5618 81.6659 57.4639 81.3971 57.3733 81.1231Z",
    fill: "url(#paint31_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8311 73.436L51.2142 74.6322C50.2904 74.9377 49.786 75.9262 50.0879 76.8393L50.3924 77.7598C50.6945 78.6735 51.6887 79.1657 52.6125 78.8602L56.2293 77.6641L54.8311 73.436Z",
    fill: "url(#paint32_linear_2829_12350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6069 59.162C87.3297 59.2536 87.0632 59.363 86.8057 59.485C87.2956 61.631 87.9081 63.8382 88.6473 66.0732C89.3626 68.2361 90.1576 70.3079 91.0111 72.266C91.2973 72.2096 91.5828 72.137 91.8669 72.043C95.4657 70.8529 97.43 67.0046 96.2536 63.4477C95.0771 59.8901 91.2057 57.9718 87.6069 59.162Z",
    fill: "url(#paint33_linear_2829_12350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2829_12350",
    x: -8.03125,
    y: -3.50781,
    width: 173.922,
    height: 173.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22,
    result: "effect1_foregroundBlur_2829_12350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2829_12350",
    x1: 67.3222,
    y1: 72.5075,
    x2: 77.1057,
    y2: 102.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2829_12350",
    x1: 61.839,
    y1: 103.66,
    x2: 74.9805,
    y2: 103.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2829_12350",
    x1: 70.3145,
    y1: 105.344,
    x2: 63.4021,
    y2: 99.0503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2829_12350",
    x1: 64.9061,
    y1: 102.194,
    x2: 70.1127,
    y2: 102.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2829_12350",
    x1: 71.2267,
    y1: 110.57,
    x2: 65.7923,
    y2: 104.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2829_12350",
    x1: 66.8104,
    y1: 107.958,
    x2: 72.0169,
    y2: 107.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2829_12350",
    x1: 66.0406,
    y1: 103.078,
    x2: 57.8587,
    y2: 88.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2829_12350",
    x1: 48.2816,
    y1: 85.0812,
    x2: 54.0412,
    y2: 92.3465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2829_12350",
    x1: 57.1538,
    y1: 79.6357,
    x2: 62.9188,
    y2: 97.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2829_12350",
    x1: 84.4864,
    y1: 67.2676,
    x2: 140.021,
    y2: 90.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2829_12350",
    x1: 101.279,
    y1: 70.5345,
    x2: 77.2537,
    y2: 78.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2829_12350",
    x1: 101.074,
    y1: 82.712,
    x2: 62.0512,
    y2: 70.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190A4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2829_12350",
    x1: 67.5118,
    y1: 80.5313,
    x2: 62.8572,
    y2: 82.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2829_12350",
    x1: 72.1426,
    y1: 79,
    x2: 67.488,
    y2: 80.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2829_12350",
    x1: 64.3892,
    y1: 85.2973,
    x2: 59.6667,
    y2: 81.8803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2829_12350",
    x1: 60.2423,
    y1: 82.1949,
    x2: 61.6835,
    y2: 86.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2829_12350",
    x1: 89.0609,
    y1: 71.178,
    x2: 94.7441,
    y2: 78.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2829_12350",
    x1: 61.532,
    y1: 63.368,
    x2: 73.8681,
    y2: 100.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2829_12350",
    x1: 54.6185,
    y1: 102.648,
    x2: 71.1886,
    y2: 102.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2829_12350",
    x1: 65.306,
    y1: 104.773,
    x2: 56.5902,
    y2: 96.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2829_12350",
    x1: 58.4866,
    y1: 100.802,
    x2: 65.0515,
    y2: 100.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2829_12350",
    x1: 66.4579,
    y1: 111.359,
    x2: 59.6056,
    y2: 103.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2829_12350",
    x1: 60.8889,
    y1: 108.069,
    x2: 67.4538,
    y2: 107.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2829_12350",
    x1: 59.9163,
    y1: 101.914,
    x2: 49.5997,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2829_12350",
    x1: 37.5263,
    y1: 79.2235,
    x2: 44.7886,
    y2: 88.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2829_12350",
    x1: 48.7126,
    y1: 72.3567,
    x2: 55.9817,
    y2: 94.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2829_12350",
    x1: 83.1762,
    y1: 56.7621,
    x2: 153.2,
    y2: 85.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2829_12350",
    x1: 104.349,
    y1: 60.8816,
    x2: 74.0554,
    y2: 70.9001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2829_12350",
    x1: 104.093,
    y1: 76.2366,
    x2: 54.8885,
    y2: 60.5166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190A4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2829_12350",
    x1: 61.7707,
    y1: 73.4864,
    x2: 55.9018,
    y2: 75.4274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2829_12350",
    x1: 67.6125,
    y1: 71.5529,
    x2: 61.7435,
    y2: 73.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2829_12350",
    x1: 57.8361,
    y1: 79.4958,
    x2: 51.8814,
    y2: 75.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#CD1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#B82E4D",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#AB3C51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2829_12350",
    x1: 52.6072,
    y1: 75.584,
    x2: 54.4244,
    y2: 81.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD00D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#FFCB0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#FFBB11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#FFA215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2829_12350",
    x1: 88.9426,
    y1: 61.6908,
    x2: 96.1086,
    y2: 70.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#FD4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#F12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#E60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4003D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2829_12350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.2052,
    height: 67.4121,
    fill: "white",
    transform: "translate(35.9688 61.9082) rotate(-18.2999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2829_12350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 85,
    fill: "white",
    transform: "translate(22 50.0039) rotate(-18.2999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatedTrumpet);
export default __webpack_public_path__ + "static/media/RotatedTrumpet.e54886bf0a91839570db9c1935241c97.svg";
export { ForwardRef as ReactComponent };